// sticky-subnav.js
(function() {
  /**
   * @param {HTMLElement} section
   */
  function initStickySubNav(section) {
    if (!section || !(section instanceof HTMLElement)) return;
    var nav = section.querySelector('.page-sub-nav');
    if (!(nav instanceof HTMLElement)) return;
    var sentinel = section.querySelector('#page-sub-nav-sentinel');
    if (!(sentinel instanceof HTMLElement)) return;

    // nav and sentinel are guaranteed to be HTMLElements here

    function stickyNavCheck() {
      var sentinelTop = sentinel.getBoundingClientRect().top;
      if (sentinelTop < 0) {
        if (!nav.classList.contains('is-fixed')) {
          nav.classList.add('is-fixed');
        }
      } else {
        if (nav.classList.contains('is-fixed')) {
          nav.classList.remove('is-fixed');
        }
      }
    }

    function updateActiveLink() {
      var navLinks = section.querySelectorAll('.page-sub-nav-links a');
      var sectionsArr = Array.from(navLinks).map(function(link) {
        var id = link.getAttribute('href').replace('#', '');
        return document.getElementById(id);
      });
      var scrollPosition = window.scrollY + window.innerHeight / 4;
      var currentSectionIndex = 0;
      for (var i = 0; i < sectionsArr.length; i++) {
        var sec = sectionsArr[i];
        if (!sec) continue;
        var secTop = sec.getBoundingClientRect().top + window.scrollY;
        if (scrollPosition >= secTop) {
          currentSectionIndex = i;
        }
      }
      navLinks.forEach(function(link, i) {
        if (i === currentSectionIndex) {
          link.classList.add('active');
        } else {
          link.classList.remove('active');
        }
      });
    }

    function onScroll() {
      stickyNavCheck();
      updateActiveLink();
    }

    // ✅ Intercept nav link clicks to adjust scroll target with offset
    nav.querySelectorAll('a[href^="#"]').forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var id = this.getAttribute('href').substring(1);
        var target = document.getElementById(id);
        if (target) {
          var NAV_OFFSET = 80; // adjust to match sticky nav height
          var targetPos = target.getBoundingClientRect().top + window.scrollY - NAV_OFFSET;

          window.scrollTo({
            top: targetPos,
            behavior: 'smooth'
          });
        }
      });
    });

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onScroll);
    onScroll(); // Initial check
    updateActiveLink(); // Initial highlight
  }

  function initAllStickySubNavs() {
    document.querySelectorAll('.page-sub-nav-wrapper').forEach(function(section) {
      if (section instanceof HTMLElement) {
        initStickySubNav(section);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAllStickySubNavs);
  document.addEventListener('shopify:section:load', function(e) {
    var section = e.target;
    if (section && section instanceof HTMLElement) {
      var wrapper = section.querySelector('.page-sub-nav-wrapper');
      if (wrapper && wrapper instanceof HTMLElement) {
        initStickySubNav(wrapper);
      }
    }
  });
})();